import { axiosInstance as axios } from "services";

export const deleteMaterialSeries = async (id) => {
  const { data } = await axios.delete(`/pricing/master/material/${id}`);
  if (!data.success) throw new Error(data.error?.message || "Failed to delete material");
  return data;
};

